export type AnnouncementRow = Record<string, unknown> & {
  id: number;
  title: string;
  description: string;
  eventType: string;
  presentedBy: string;
  startDateTime: string;
  endDateTime: string;
  venue: string;
  mode: string;
  status: string;
  attachment?: string | null;
  file?: string | null;
};

export function announcementAttachmentName(path: string | null | undefined): string | null {
  if (!path) return null;
  return path.split("/").reverse().find((part) => /\.(pdf|jpe?g|png)$/i.test(part)) ?? null;
}

export function announcementStatusVariant(status: string): "success" | "warning" | "danger" | "neutral" {
  switch (status.toUpperCase()) {
    case "ONGOING":
    case "APPROVED":
      return "success";
    case "UPCOMING":
    case "PENDING":
      return "warning";
    case "REJECTED":
      return "danger";
    default:
      return "neutral";
  }
}

export function announcementStatusLabel(status: string): string {
  switch (status.toUpperCase()) {
    case "APPROVED": return "Approved";
    case "PENDING": return "Pending";
    case "REJECTED": return "Rejected";
    case "UPCOMING": return "Upcoming";
    case "ONGOING": return "Ongoing";
    case "PAST": return "Past";
    default: return status;
  }
}

/** Announcement dates are sent as timezone-free India local times by the API. */
function announcementTime(value: string): number {
  const dateTime = value.trim().replace(" ", "T");
  const hasTimezone = /(Z|[+-]\d{2}:?\d{2})$/i.test(dateTime);
  return Date.parse(hasTimezone ? dateTime : `${dateTime}+05:30`);
}

export function announcementEventStatus(row: AnnouncementRow, now = Date.now()): string {
  const start = announcementTime(row.startDateTime);
  const end = announcementTime(row.endDateTime);
  if (!Number.isFinite(start) || !Number.isFinite(end)) return row.status;
  if (now < start) return "Upcoming";
  if (now > end) return "Past";
  return "Ongoing";
}
